module.exports = __webpack_public_path__ + "img/image44.b15de13d.webp";